import { Link } from "react-router-dom";
import { Lock, ArrowRight } from "lucide-react";

/**
 * Casella del Calendario dell'Avvento.
 * Stessa grafica per pubblico e anteprima admin: illustrazione verticale 1:2
 * (ambientazione 1-2-3) integra, senza tagli di logo o orsetto.
 * Numero e titolo sono testo sovrapposto nello spazio centrale vuoto,
 * con posizione, font e dimensioni identiche su tutte le 24 caselle.
 */
export default function AdventDoor({ day, title = "", themeUrl = "", unlocked = false, testId }) {
  const inner = (
    <>
      {themeUrl ? (
        <img
          src={themeUrl}
          alt=""
          loading="lazy"
          className={`absolute inset-0 w-full h-full object-cover transition duration-300 ${
            unlocked ? "group-hover:scale-[1.04]" : "brightness-[0.72] saturate-[0.5]"
          }`}
        />
      ) : (
        <div className={`absolute inset-0 ${unlocked ? "bg-[#FFE4E8]" : "bg-[#3D2140]/10"}`} />
      )}

      {/* Numero + titolo sovrapposti nella zona centrale vuota dell'illustrazione */}
      <div className="absolute inset-0 flex flex-col items-center justify-center gap-1.5 px-1.5">
        <span
          className={`flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-full font-display text-xl md:text-2xl shadow-md transition-colors shrink-0 ${
            unlocked
              ? "bg-[#FAF8F5]/95 text-[#3D2140] group-hover:bg-[#FF2768] group-hover:text-white"
              : "bg-[#FAF8F5]/75 text-[#3D2140]/55"
          }`}
        >
          {day}
        </span>
        {unlocked && title && (
          <span className="bg-[#FAF8F5]/90 rounded-lg px-1.5 py-1 shadow-sm max-w-full">
            <span className="block text-[9px] md:text-[10px] leading-tight text-[#3D2140] font-semibold text-center line-clamp-2">
              {title}
            </span>
          </span>
        )}
      </div>

      {unlocked ? (
        <ArrowRight className="absolute top-2 right-2 text-[#3D2140]/60 drop-shadow opacity-70 group-hover:opacity-100 group-hover:text-[#FF2768]" size={14} />
      ) : (
        <div className="absolute top-2 right-2 flex items-center justify-center w-6 h-6 rounded-full bg-[#3D2140]/50">
          <Lock className="text-white" size={11} />
        </div>
      )}
    </>
  );

  const cls = `group block aspect-[1/2] relative rounded-2xl shadow-md overflow-hidden transition ${
    unlocked ? "hover:shadow-xl" : "cursor-not-allowed"
  }`;

  if (unlocked) {
    return (
      <Link to={`/calendario-avvento-2026/giorno-${day}`} data-testid={testId} className={cls} title={title}>
        {inner}
      </Link>
    );
  }
  return (
    <div data-testid={testId} className={cls} title="Non ancora disponibile">
      {inner}
    </div>
  );
}
